import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import BookingItem from '../../molecules/BookingItem';
import Button from '../../atoms/Button';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../../utils/urls';
import RadioGroup from '../../atoms/Radio/RadioGroup';
import Radio from '../../atoms/Radio';

import { DriverDispatchProducts } from '../../../utils/EstimateFormData';
import { useDriverDispatchOptionContext } from '../../organisms/DriverDispatchOptionContext';

import { useDispatch } from 'react-redux';
import { updateDriverDispatchSubscription } from '../../../reducers/driverDispatchEstimation';
import PageTitle from '../../atoms/PageTitle';
import BookingFormSummary from '../../atoms/BookingFormSummary';
import { getValueByTarget } from '../../../utils/parse'
import useCheckPC from '../../../hooks/useCheckPC';
import MobileDescriptionPop from '../../organisms/MobileDescriptionPop';

import { getQueryStringObject, getEstimateCookieData, getDdEstimateCookieDataAndDecrypt } from '../../../lib/Util';
import { useCookies } from 'react-cookie'
import { openLoading, closeLoading } from '../../../reducers/loadingRedux';
import { ESTIMATE_TYPE_MONTHLY_MOSILER, ESTIMATE_TYPE_DRIVER_DISPATCH, PAGE } from '../../../utils/constant';
import {
	setSheetContractResponseTest,
	setSheetEstimateResponseTest,
	setSheetContractResponse,
	setSheetEstimateResponse,
	SetMmEstimateHistory,
	GetMmEstimateLatestHistory
} from '../../../lib/EstimateApi';
import BookingFormSummary2 from '../../atoms/BookingFormSummary2';
import BookingItem2SizeUp from '../../molecules/BookingItem2SizeUp';
/*
dispatch(openLoading())
dispatch(closeLoading())
		// await하지 않고, 모시러 서버에 저장
		await SetMmEstimateHistory({
			UserName: 'rise',
			PhoneNumber: '01087223834',
			EmailAddress: 'rise@mosiler.com',
			EstimateType: ESTIMATE_TYPE_MONTHLY_MOSILER,
			EstimatePage: PAGE.PAGE_01,
			JsonData: JSON.stringify({
				...selectedOptions,
				subscription: data?.subscription ?? selectedOptions.subscription
			})
		})

*/



/**
 * 상품 선택 페이지
 * name : subscription
 * */

const Subscription = () => {
	const { isPC } = useCheckPC();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { selectedOptions, setSelectedOptions } = useDriverDispatchOptionContext();
	const [showDescription, setShowDescription] = useState(false)
	const [cookies, setCookie, removeCookie] = useCookies();

	const { handleSubmit, setValue } = useForm();

	useEffect(() => {
		function initData() {
			try {
				let qs = getQueryStringObject()
				if (qs.estimateddinfo.length) {
					setCookie('estimateddinfo', qs.estimateddinfo, { path: '/' })
				}
			}
			catch (e) {

			}
		}
		initData()
	}, [])




	const onSubmit = handleSubmit(async data => {

		// Loading Start
		dispatch(openLoading())

		setSelectedOptions((prevOptions) => ({
			...prevOptions,
			subscription: data?.subscription ?? selectedOptions.subscription,
		}));

		// await하지 않고, 모시러 서버에 저장
		SetMmEstimateHistory({
			...getDdEstimateCookieDataAndDecrypt(),
			EstimateType: ESTIMATE_TYPE_DRIVER_DISPATCH,
			EstimatePage: PAGE.PAGE_01,
			JsonData: JSON.stringify({
				...selectedOptions,
				subscription: data?.subscription ?? selectedOptions.subscription
			})
		})

		dispatch(updateDriverDispatchSubscription(data?.subscription ?? selectedOptions.subscription))

		// Loading End
		dispatch(closeLoading())

		navigate(URLS.DRIVER_DISPATCH_USAGE_TIME)

		/*
		BookingOptionContext에 있는 값중  아래 값에 대해서
		초기화 하는 작업이 필요하고
		그 Key값은 
		EstimateFormData상의 OptionDict에 있는 데이터
		  
		  usageTime: selectedOptions.usageTime,
		  numberOfVehicles: selectedOptions.vehicleOption.numberOfVehicles,
		  roleOfVehicles: selectedOptions.vehicleOption.roleOfVehicles,
		  periodOfContract: selectedOptions.contractTerms1.periodOfContract,
		  departure: selectedOptions.contractTerms1.serviceArea.departure,
		*/
	});

	const updateInitializeAmount = (source, subscription) => {
		if (subscription === 'annual') {
			return {
				...source,
				usageTime: 'annual_1year_100h',
				subscription: subscription,
				vehicleOption: {
					...source.vehicleOption,
					numberOfVehicles: 'twoVehicles',
					roleOfVehicles: 'driver',
					carAmount: 'twomilliondown',
					insurance: 'insucustomer',
					passengerPerson: 'persontwo',
				},
				contractTerms1: {
					...source.contractTerms1,
					periodOfContract: 'month1',
				},
			}
		}


		return {
			...source,
			usageTime: 'day10',
			subscription: subscription,
			vehicleOption: {
				...source.vehicleOption,
				numberOfVehicles: 'twoVehicles',
				roleOfVehicles: 'driver',
				carAmount: 'twomilliondown',
				insurance: 'insucustomer',
				passengerPerson: 'persontwo',
			},
			contractTerms1: {
				...source.contractTerms1,
				periodOfContract: 'month1',
			},
		}
		//    
	}

	// 맨처음 상품을 변경할 때,금액 초기화 처리 필요.
	// 

	return (
		<>
			<div className={classNames('booking-wrap')}>
				<PageTitle
					title={'상품 선택'}
					subtitle={'이용하실 상품을 선택하세요'}
					setShowDescription={setShowDescription}
				/>
				<form className={classNames('booking-form')} onSubmit={onSubmit}>
					<div className={classNames('booking-select-list')}>
						{!!DriverDispatchProducts && (
							<RadioGroup
								classes={''}
								legend={'subscription'}
								selected={selectedOptions.subscription}
							>
								<ul className={classNames('booking-item-list')}>
									{DriverDispatchProducts.map((item) => (
										<li key={item.title}>
											<Radio
												key={item.title}
												value={item.value}
												onChange={e => {
													// console.log('hello')
													setValue('subscription', item.value);
													setSelectedOptions((prevOptions) => ({
														...prevOptions,
														subscription: item.value
													}));
													//setSelectedOptions((prevOptions) => updateInitializeAmount(prevOptions, item.value));

													// usageTime을 day10으로 하니 초기화가 되었음
													// 이게 확인 되었으므로 item.value 값에 따라 요소들을 초기화 시켜주면됨.
												}}
											>
												<BookingItem2SizeUp
													selected={selectedOptions.subscription === item.value}
													title={item?.title}
													subtitle={item?.subtitle}
													// priceTitle={''}
													// price={item?.price}

													priceUnstable={true}
												/>
											</Radio>
										</li>
									))}
								</ul>
							</RadioGroup>
						)}
					</div>
					<BookingFormSummary2
						description={
							getValueByTarget(
								DriverDispatchProducts,
								selectedOptions.subscription,
								'description'
							)
						}>
						<div className={classNames('button-set')}>
							<Button
								styleType={'secondary'}
								type={'submit'}
							>다음</Button>
						</div>
					</BookingFormSummary2>
				</form>
			</div>
			{showDescription && !isPC && (
				<MobileDescriptionPop
					targetDictList={DriverDispatchProducts}
					setShowDescription={setShowDescription}
					selectedOptions={selectedOptions}
				/>
			)}
		</>
	)
}
export default Subscription